(function () {
  var MOBILE_MQ = '(max-width: 989px)';

  function initGallery(root) {
    if (root.dataset.productsLeftBound === 'true') return;
    root.dataset.productsLeftBound = 'true';

    var panels = root.querySelectorAll('[data-products-left-panel]');
    var thumbs = root.querySelectorAll('[data-products-left-thumb]');
    var thumbTrack = root.querySelector('[data-products-left-thumbs]');
    var prevBtn = root.querySelector('[data-products-left-prev]');
    var nextBtn = root.querySelector('[data-products-left-next]');
    var counterCurrent = root.querySelector('[data-products-left-counter-current]');
    var lightbox = root.querySelector('[data-products-left-lightbox]');
    var lightboxImg = root.querySelector('[data-products-left-lightbox-img]');
    var lightboxClose = root.querySelector('[data-products-left-lightbox-close]');
    if (!panels.length) return;

    var activeIndex = 0;
    var observer = null;

    function isMobileCarousel() {
      return window.matchMedia(MOBILE_MQ).matches;
    }

    function getThumbScrollStep() {
      if (!thumbTrack || !thumbs[0]) return 0;
      var styles = window.getComputedStyle(thumbTrack);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return thumbs[0].offsetWidth + gap;
    }

    function updateCounter() {
      if (!counterCurrent) return;
      counterCurrent.textContent = String(activeIndex + 1);
    }

    function setActive(index) {
      activeIndex = Math.max(0, Math.min(index, panels.length - 1));

      panels.forEach(function (panel, i) {
        panel.classList.toggle('is-active', i === activeIndex);
      });

      thumbs.forEach(function (thumb, i) {
        var isActive = i === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      updateCounter();
      updateNavState();
    }

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;

      if (isMobileCarousel()) {
        prevBtn.disabled = activeIndex <= 0;
        nextBtn.disabled = activeIndex >= panels.length - 1;
        return;
      }

      if (!thumbTrack) {
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        return;
      }

      var maxScroll = thumbTrack.scrollWidth - thumbTrack.clientWidth;
      var atStart = thumbTrack.scrollLeft <= 1;
      var atEnd = thumbTrack.scrollLeft >= maxScroll - 1;

      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd || maxScroll <= 0;
    }

    function scrollThumbTrack(direction) {
      if (!thumbTrack) return;
      var step = getThumbScrollStep();
      if (!step) return;

      thumbTrack.scrollBy({
        left: direction * step,
        behavior: 'smooth',
      });
    }

    function scrollActiveThumbIntoView(index) {
      var thumb = thumbs[index];
      if (!thumb || !thumbTrack || isMobileCarousel()) return;

      var trackRect = thumbTrack.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();
      var deltaLeft = thumbRect.left - trackRect.left;
      var deltaRight = thumbRect.right - trackRect.right;

      if (deltaLeft < 0) {
        thumbTrack.scrollBy({ left: deltaLeft, behavior: 'smooth' });
      } else if (deltaRight > 0) {
        thumbTrack.scrollBy({ left: deltaRight, behavior: 'smooth' });
      }
    }

    function openLightbox(index) {
      var thumb = thumbs[index];
      if (!thumb || !lightbox || !lightboxImg) return;

      var thumbImg = thumb.querySelector('img');
      var src =
        (thumbImg && thumbImg.getAttribute('src')) ||
        thumb.getAttribute('data-products-left-lightbox-src');
      if (!src) return;

      lightboxImg.src = src;
      lightboxImg.alt = thumb.getAttribute('aria-label') || '';

      if (typeof lightbox.showModal === 'function') {
        lightbox.showModal();
      }
    }

    function closeLightbox() {
      if (lightbox && lightbox.open) {
        lightbox.close();
      }
    }

    function handleNav(direction) {
      if (isMobileCarousel()) {
        setActive(activeIndex + direction);
        return;
      }
      // Desktop: scroll the thumbnail strip — do not scroll the page.
      scrollThumbTrack(direction);
    }

    function bindObserver() {
      if (!('IntersectionObserver' in window)) return;

      if (observer) {
        observer.disconnect();
        observer = null;
      }

      if (isMobileCarousel()) return;

      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              var index = parseInt(entry.target.getAttribute('data-products-left-panel'), 10);
              if (!isNaN(index)) {
                setActive(index);
                scrollActiveThumbIntoView(index);
              }
            }
          });
        },
        { root: null, threshold: [0.5] }
      );

      panels.forEach(function (panel) {
        observer.observe(panel);
      });
    }

    function handleThumbClick(index) {
      if (isNaN(index)) return;

      if (isMobileCarousel()) {
        setActive(index);
        return;
      }

      // Desktop: preview the carousel image that was clicked.
      openLightbox(index);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        handleThumbClick(parseInt(thumb.getAttribute('data-products-left-thumb'), 10));
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        handleNav(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        handleNav(1);
      });
    }

    if (thumbTrack) {
      thumbTrack.addEventListener('scroll', updateNavState, { passive: true });
    }

    if (lightboxClose) {
      lightboxClose.addEventListener('click', closeLightbox);
    }

    if (lightbox) {
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) closeLightbox();
      });

      lightbox.addEventListener('close', function () {
        if (lightboxImg) {
          lightboxImg.removeAttribute('src');
        }
      });
    }

    window.addEventListener(
      'resize',
      function () {
        bindObserver();
        updateNavState();
      },
      { passive: true }
    );

    setActive(0);
    bindObserver();
    updateNavState();
  }

  function initAll() {
    document.querySelectorAll('[data-products-left]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-products-left]').forEach(function (root) {
      root.dataset.productsLeftBound = 'false';
      initGallery(root);
    });
  });
})();
